module.exports = __webpack_public_path__ + "media/images/icons/basket-b479dca08ae15761c853a1dc4bd08390.svg";